import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex } from '@chakra-ui/react';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useId, createElement as _createElement } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AnimatePresenceCompat = AnimatePresence;
var MotionBox = motion(Box);
export function AnimatedCheckbox(_ref) {
  var isChecked = _ref.isChecked,
    _onChange = _ref.onChange,
    children = _ref.children,
    containerProps = _ref.containerProps,
    testId = _ref['data-testid'];
  var id = useId();
  return _jsxs(Flex, _objectSpread(_objectSpread({
    as: "label",
    htmlFor: id,
    align: "flex-start",
    gap: "sm",
    cursor: "pointer",
    "data-testid": testId
  }, containerProps), {}, {
    children: [_jsx("input", {
      style: hiddenInputStyle,
      type: "checkbox",
      id: id,
      checked: isChecked,
      onChange: e => _onChange(e.target.checked),
      "data-testid": testId ? "".concat(testId, "-Input") : undefined
    }), _jsx(MotionBox, _objectSpread(_objectSpread({}, checkboxControlStyle), {}, {
      "aria-hidden": true,
      flexShrink: 0,
      animate: {
        borderColor: isChecked ? brandPurple : borderUnchecked
      },
      transition: {
        duration: 0.15,
        ease: 'easeInOut'
      },
      children: _jsx(AnimatePresenceCompat, {
        initial: false,
        children: isChecked && _createElement(MotionBox, _objectSpread(_objectSpread({}, checkboxInnerStyle), {}, {
          key: "inner",
          initial: {
            scale: 0,
            opacity: 0
          },
          animate: {
            scale: 1,
            opacity: 1
          },
          exit: {
            scale: 0,
            opacity: 0
          },
          transition: {
            duration: 0.15,
            ease: 'easeInOut'
          }
        }))
      })
    })), children]
  }));
}
var brandPurple = 'var(--chakra-colors-midPurple)';
var borderUnchecked = 'var(--chakra-colors-midGrey)';
var hiddenInputStyle = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0
};
var checkboxControlStyle = {
  w: '20px',
  h: '20px',
  minW: '20px',
  borderWidth: '1.5px',
  borderStyle: 'solid',
  borderColor: 'midGrey',
  borderRadius: '0',
  bg: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  mt: '2px'
};
var checkboxInnerStyle = {
  w: '10px',
  h: '10px',
  bg: 'midPurple',
  flexShrink: 0
};